<template>
    <div>
      <h3 class="ba-mulish-800 box-title" v-text="t('associate_tokens_link_information')"></h3>
      <div class="box-associate-tokens ba-flex ba-ai-center ba-jc-sb">
        <div class="ba-flex ba-f-row container-link">

        <span class="ba-flex" v-text="`${t('label_link')}:`"></span>
        <div class="header-link ba-flex ba-ai-center ba-f-column ba-gp-04 ba-jc-fe ba-mulish-500">
          <fs5-input-copy :view="['', this.shareLink, t('copied')]" :styleType="'link-affiliate'" :tooltip="t('associate_tokens_link_tooltip')"/>
           {{ `${t('associate_link_id')}: ${this.userId}` }}
        </div>
        </div>
        <div class="ba-flex ba-f-column">
          <p class="ba-mulish-400" v-text="`${t('available_monthly_invites')}: ${t(this.available)}`"></p>
          <div class="ba-flex">
            <button :disabled="!this.canRequest || this.loading" class="ba-btn ba-sm ba-blue" @click="request()">
              {{ t('request_more_invites') }}
              <svg v-if="this.loading" width="18" height="18" viewBox="1 -4 38 50" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g fill="none" fill-rule="evenodd">
                  <g transform="translate(1 1)" stroke-width="6">
                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                    <path d="M36 18c0-9.94-8.06-18-18-18">
                      <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
                    </path>
                  </g>
                </g>
              </svg>
            </button>
            <builderall-icon
              code='help'
              ba-tooltip-position='right'
              ba-tooltip-color='dark'
              :ba-tooltip-title="t('associate_tokens_tooltip')"
            ></builderall-icon>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: 'associate-tokens',
        props: {
            data:{
                type: Object,
                required: true
            },
            translations:{
                type: Array,
                required: true
            }
        },
        data: function() {
            return {
                shareLink: '',
                available: '',
                requestRoute: '',
                userId: '',
                canRequest: false,
                loading: false,
            }
        },
        methods: {
            t(key) {
                return this.translations[key] || key;
            },
            request() {
              this.loading = true;
              axios.get(this.requestRoute)
                .then((response) => {
                    if(response.data.success) {
                      alertMsg('success', this.t('request_success'));
                      this.requestApproved(response.data.data.share_link);
                    }
                })
                .catch((err) => {
                    alertMsg('error', this.t('request_error'));
                })
                .finally(() => {
                  this.loading = false;
                });
            },
            requestApproved(link) {
              this.canRequest = false;
              this.available = this.data.limit +' / '+ this.data.limit;
              this.shareLink = link;
            }
        },
        mounted() {
          this.shareLink = this.data.link;
          this.available = this.data.available;
          this.requestRoute = this.data.request_link;
          this.userId = this.data.user_id;
          this.canRequest = this.data.can_request;
        }
    }
</script>

<style scoped lang="scss">
  @import '../../../../../scss/extras/_variables';

  builderall-icon {
    --builderall-icon-size: 20px;
    margin: 0 5px;
  }

  .box-title {
    color: $primary-color;
    text-align: center;
    font-size: 20px;
  }

  .box-associate-tokens {
    margin: 1em 2em;
    .header-link {
      color: $fs5-color28;
      font-size: 13px;
      width: 100%;
    }
    .container-link{
      width: 33%;

      span {
        align-items: center;
        font-size: 13px;
        margin: 0 10px 0 0;
      }
    }
  }

  p {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/associate-tokens/index.vue